import { Suspense, useState } from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import * as Admin from "../components/admin";
import * as Coordinator from "../components/coordinator";
import * as Student from "../components/student";
import ErrorPage from "../pages/NotFound";
import Layout from "../layout/Layout";
import Login from "../layout/login/Login";
import { UserRoles } from "../shared/constants/enums";
import { useSelector } from "react-redux";
import AuthenticatedProtectedRoute from "./AuthenticatedProtectedRoute";
import {
  IPublicClientApplication,
  PublicClientApplication,
} from "@azure/msal-browser";
import {
  msalStaffConfig,
  msalStudentConfig,
} from "../layout/login/auth/authConfig";
import Logout from "../layout/Logout";

function AppRoutes() {
  const auth = useSelector((state: any) => state.login);

  const userRole = auth?.userInfo?.roleId;
  const [instance, setInstance] = useState(
    new PublicClientApplication(
      userRole !== UserRoles.NURSING_STUDENT
        ? msalStudentConfig
        : msalStaffConfig
    )
  );
  instance.initialize();

  const setInstanceCallback = (i: PublicClientApplication) => {
    setInstance(i);
  };

  return (
    <Suspense fallback={<h1>Loading...</h1>}>
      <Routes>
        <Route
          path="/"
          element={<Login instanceCallback={setInstanceCallback} />}
        />
        <Route path="/logout" element={<Logout MSALInstance={instance} />} />
        <Route
          path="admin"
          element={
            <AuthenticatedProtectedRoute
              MSALInstance={instance}
              currentUserRole={userRole}
              authorizedRole={UserRoles.SUPER_USER}
            >
              <Layout />
            </AuthenticatedProtectedRoute>
            // <ProtectedRoute role={UserRoles.SUPER_USER}>
            //   <Layout />
            // </ProtectedRoute>
          }
        >
          <Route index element={<Admin.Dashboard />} />
          <Route path="home" element={<Admin.Dashboard />} />
          <Route
            path="template/:currentTemplateId"
            element={<Admin.CaseDetails />}
          />
          <Route
            path="createtemplate/:id?"
            element={<Admin.CreateTemplate />}
          />
          <Route
            path="templatelibrary"
            element={<Admin.TemplateLibrary userRole={userRole} />}
          />
          <Route
            path="templatelibrary/assignStudent/:currentTemplateId"
            element={<Admin.AssignStudent />}
          />
          <Route path="managerole" element={<Admin.ManageRole />} />
          <Route path="archive" element={<Admin.AdminArchive />} />
          <Route path="*" element={<ErrorPage />} />
        </Route>
        <Route
          path="coordinator"
          element={
            <AuthenticatedProtectedRoute
              MSALInstance={instance}
              currentUserRole={userRole}
              authorizedRole={UserRoles.SUBJECT_COORDINATOR}
            >
              <Layout />
            </AuthenticatedProtectedRoute>
            // <ProtectedRoute role={UserRoles.SUBJECT_COORDINATOR}>
            //   <Layout />
            // </ProtectedRoute>
          }
        >
          <Route
            index
            element={<Coordinator.Dashboard currentRole={userRole} />}
          />
          <Route
            path="home"
            element={<Coordinator.Dashboard currentRole={userRole} />}
          />
          <Route
            path="templatelibrary/assignStudent/:currentTemplateId"
            element={<Coordinator.AssignStudent />}
          />
          <Route
            path="template/:currentTemplateId"
            element={<Coordinator.CaseDetails />}
          />
          <Route
            path="nursingstudentlist"
            element={<Coordinator.NursingStudentList />}
          />
          <Route path="*" element={<ErrorPage />} />
        </Route>
        <Route
          path="student"
          element={
            <AuthenticatedProtectedRoute
              MSALInstance={instance}
              currentUserRole={userRole}
              authorizedRole={UserRoles.NURSING_STUDENT}
            >
              <Layout />
            </AuthenticatedProtectedRoute>
            // <ProtectedRoute role={UserRoles.NURSING_STUDENT}>
            //   <Layout />
            // </ProtectedRoute>
          }
        >
          <Route index element={<Student.Dashboard />} />
          <Route path="home" element={<Student.Dashboard />} />
          <Route
            path="casedetails/:currentCaseId"
            element={<Student.CaseDetails />}
          />
          <Route path="shiftplanner" element={<Student.Shiftplanner />} />
          <Route path="adhoc" element={<Student.Adhoc />} />
          <Route path="links" element={<Student.Links />} />
          <Route path="*" element={<ErrorPage />} />
        </Route>
        <Route
          path="tutor"
          element={
            <AuthenticatedProtectedRoute
              MSALInstance={instance}
              currentUserRole={userRole}
              authorizedRole={UserRoles.TUTOR}
            >
              <Layout />
            </AuthenticatedProtectedRoute>
            // <ProtectedRoute role={UserRoles.NURSING_STUDENT}>
            //   <Layout />
            // </ProtectedRoute>
          }
        >
          <Route index element={<Student.Dashboard />} />
          <Route path="home" element={<Student.Dashboard />} />
          <Route
            path="casedetails/:currentCaseId"
            element={<Student.CaseDetails />}
          />
          <Route path="shiftplanner" element={<Student.Shiftplanner />} />
          <Route path="adhoc" element={<Student.Adhoc />} />
          <Route path="links" element={<Student.Links />} />
          <Route path="*" element={<ErrorPage />} />
        </Route>
        <Route path="/*" element={<ErrorPage />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
